import { render, staticRenderFns } from "./HeaderSlot.vue?vue&type=template&id=4b86f8a1&scoped=true&"
import script from "./HeaderSlot.vue?vue&type=script&lang=js&"
export * from "./HeaderSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b86f8a1",
  null
  
)

export default component.exports